import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { MarkdownPreview } from "../../core/ui/markdown/markdown_preview";
import { LearningStore } from "./learning_store";
import { PageHeading, Pagination } from "./learning_lobby";

export const BankScreen = observer(
  ({ store, go }: { store: LearningStore; go: (id?: string) => void }) => {
    const [query, setQuery] = useState(store.bankQuery);
    useEffect(() => {
      store.searchBank(store.bankPage);
    }, [store]);
    return (
      <>
        <PageHeading title="Банк заданий" />
        <form
          className="bank-filters"
          onSubmit={(event) => {
            event.preventDefault();
            store.searchBank(0, store.bankTag, query);
          }}
        >
          <label>
            Тема
            <select
              value={store.bankTag}
              onChange={(event) =>
                store.searchBank(0, event.target.value, query)
              }
            >
              <option value="">Все темы</option>
              {store.bankTopics.map((topic) => (
                <option value={topic.tag} key={topic.tag}>
                  {topic.tag} ({topic.count})
                </option>
              ))}
            </select>
          </label>
          <label>
            Поиск по названию
            <input
              value={query}
              maxLength={200}
              onChange={(event) => setQuery(event.target.value)}
              placeholder="Название задания"
            />
          </label>
          <button type="submit" disabled={store.bankBusy}>
            Найти
          </button>
        </form>
        {store.bankBusy && <p role="status">Загрузка заданий…</p>}
        {store.bankError && (
          <div role="alert" className="portal-error">
            {store.bankError}
            <button onClick={() => store.searchBank(store.bankPage)}>
              Повторить
            </button>
          </div>
        )}
        {!store.bankError && !store.bankBusy && !store.bankTasks.length && (
          <p className="portal-card">Заданий не найдено.</p>
        )}
        {store.bankTasks.map((task) => (
          <article className="portal-card bank-task" key={task.id}>
            <div className="section-heading">
              <h2>{task.title}</h2>
              <p className="portal-muted">{task.scoreAmount} баллов</p>
            </div>
            <MarkdownPreview value={task.description} label="Условие задания" />
            {!!task.options?.length && (
              <ol className="bank-options">
                {task.options.map((option, index) => (
                  <li key={index}>{option}</li>
                ))}
              </ol>
            )}
            <div className="bank-task-footer">
              <p className="portal-muted">
                {task.tags?.join(", ") || "Без темы"}
              </p>
              <button
                className="portal-primary"
                disabled={store.busy || store.bankBusy}
                onClick={async () => {
                  const id = await store.startBankTask(task.id);
                  if (id) go(id);
                }}
              >
                Решить задание
              </button>
            </div>
          </article>
        ))}
        <Pagination
          page={store.bankPage}
          busy={store.bankBusy}
          hasNext={store.bankHasNext}
          onPage={(page) => store.searchBank(page)}
        />
      </>
    );
  },
);
